import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

const contentMaxWidth = "760px";

/*
 * The band is a direct child of Page's flex column, whose main is `flex: 1 0 auto`.
 * flex-shrink: 0 stops the band being compressed instead of main once the page's
 * natural content exceeds 100vh.
 */
export const band = (theme: Theme) => css`
  flex-shrink: 0;
  background-color: ${theme.ds5.success.backgroundLevel1};
  border-top: 1px solid ${theme.ds5.success.border};
`;

export const content = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.spacing.gap.large};
  max-width: ${contentMaxWidth};
  margin: 0 auto;
  padding: 32px 24px;

  @media (max-width: ${dimensions.tabletMax}) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

/*
 * The copy column cannot shrink below its min-content width, so without this the
 * illustration absorbs the overflow and renders as a squashed oval.
 */
export const illustration = css`
  flex-shrink: 0;
`;

export const copy = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.ds5.spacing.gap.small};
`;
